import { TransactionState, useNftx } from '@nftx/react';
import ApproveItem from './ApproveItem';
import useAddress from '@/application/read/web3/useAddress';
import useApprove from '@/application/write/approvals/useApprove';
import { useState } from 'react';
import { Address } from 'nftx.js';

type ApproveItemContainerProps = {
  type: 'on-chain' | 'permit2';
  spenderAddress: Address;
  tokenAddress: Address;
  standard: 'ERC721' | 'ERC1155' | 'ERC20';
  tokenIds?: `${number}`[];
  amount?: bigint;
  index: number;
  symbol: string;
  label?: string;
};

const ApproveItemContainer = ({
  type,
  spenderAddress,
  tokenAddress,
  standard,
  tokenIds,
  amount,
  index,
  symbol,
  label,
}: ApproveItemContainerProps) => {
  const {
    provider,
    core: { isApproved },
  } = useNftx();
  const userAddress = useAddress();
  const [approve, { error, status: approveStatus }] = useApprove();

  const [alreadyApproved, setAlreadyApproved] = useState(false);
  const status: TransactionState = alreadyApproved ? 'Success' : approveStatus;

  const action = async () => {
    if (userAddress) {
      const approved = await isApproved({
        type,
        provider,
        spenderAddress,
        tokenAddress,
        userAddress,
        standard,
        tokenIds,
        amount,
      });

      if (approved) {
        setAlreadyApproved(true);
        return;
      }

      approve({
        type,
        spenderAddress,
        tokenAddress,
        tokenIds,
        standard,
        amount,
      });
    }
  };

  return (
    <ApproveItem
      action={action}
      status={status}
      error={error}
      index={index}
      symbol={symbol}
      label={label}
    />
  );
};

export default ApproveItemContainer;
